module.exports = __webpack_public_path__ + "img/national_result_example_2.441c7f94.png";